module.exports = __webpack_public_path__ + "img/health.475ac25c.png";